export default __webpack_public_path__ + "bg_anli_jiaoyu01f76974.png";